export async function reloadCurrentRoute(router) {
  const currentUrl = router.url;
  await router.navigateByUrl('/', { skipLocationChange: true });
  router.navigate([currentUrl]);
}

export async function navigateWithReload(router, url) {
  await router.navigateByUrl('/', { skipLocationChange: true });
  router.navigate([url]);
}
